export default "__VITE_ASSET__Cqc7xGVx__"